module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNG105e23c11c46ed201f2ff2ad2acb4ade.105e23c1.png";